import CheckboxMaterial from "./material/Checkbox";

const ContactForm = (props) => {
	return (
		<div className="pd-contact-form">
			<form className="pd-material__form">
				<fieldset className="pd-material__fieldset">
					<div className="pd-contact-form__container">{props.children}</div>
					<div className="pd-contact-form__action">
						<div className="pd-contact-form__action__checkbox">
							<CheckboxMaterial name="rodo" required onCheckbox={props.onCheckbox}>
								Dane wpisane w formularzu kontaktowym będą przetwarzane w celu udzielenia odpowiedzi
								na wysłane zapytanie. Administratorem danych osobowych jest o4b Sp. z o.o. z
								siedzibą przy ulicy Granicznej 4 / 9, 20-010 Lublin.
							</CheckboxMaterial>
						</div>
						<div className="pd-contact-form__action__button">
							<button className="pd-btn pd-btn--primary" type="submit" onClick={props.onClick}>
								Wyślij
							</button>
						</div>
					</div>
					<div className="pd-contact-form__response">
						{props.responsePositive === true && (
							<p className="pd-contact-form__response--positive">
								Twoja wiadomość została wysłana. Dziękujemy!
							</p>
						)}
						{props.responsePositive === false && (
							<p className="pd-contact-form__response--negative">
								Przynajmniej jedno pole jest błędnie wypełnione. Sprawdź wpisaną treść i spróbuj
								ponownie.
							</p>
						)}
					</div>
				</fieldset>
			</form>
		</div>
	);
};

export default ContactForm;
